// extracted by mini-css-extract-plugin
module.exports = {"buttonHolder":"DeviceToggle_buttonHolder__3ExG7"};